<div class="content-inner loading" *ngIf="loading"></div>

<ng-template [ngIf]="!loading">      
    <div class="content-inner" *ngIf="prevShiftRecord">
        <div class="workflow-section-heading">Room Activity Categories</div>
        <span *ngIf="hasRoomAcuityRecords" class="enableEditing" (click)="toggleIsEditing()" role="button"><span class="icon-pencil"></span> Edit</span>
       
        <form [formGroup]="previousBlockForm" class="form-body">
            <div *ngFor="let roomType of prevShiftRecord.costCenter.ancillaryConfiguration.roomTypes" class="roomType">
                {{ roomType.name }}
                <div *ngFor="let room of roomType.rooms" class="room">
                    <label>{{ room.name }}</label>
                    <select name="acuityCategory" formControlName="room{{room.id}}" [attr.disabled]="isEditing?null:'true'">
                        <option value=""> </option>
                        <option value="vacant">No Occupancy</option>
                        <option *ngFor="let acuityCategory of acuityCategories"
                            [value]="acuityCategory.id">
                            {{ acuityCategory.name }}                        
                        </option>
                    </select>
                </div>
            </div>
            <input id="reviewed" type="checkbox" value="checkbox" formControlName="reviewed">
            <label for="reviewed">Reviewed</label>
            <div class="warning info" *ngIf="!hasRoomAcuityRecords">* The information recorded during the previous block is incomplete.  Please complete your missing shift block.</div>
        </form>
    </div>
    <div *ngIf="!prevShiftRecord" class="no-previous-block">
        This cost center has no previous shift block.  Please proceed to the next page.
    </div>
</ng-template>
